import React from 'react'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import pc from '../assets/pc.svg'
import ps4 from '../assets/ps4.svg'
import xbox from '../assets/xbox.svg'
import mobile from '../assets/android.svg'
import apple from '../assets/ios.svg'

function Games() {
    const [data, setData] = React.useState([]);
    React.useEffect(() => {
        fetch('/data.json').then((res) => res.json()).then((data) => {
            setData(data);
        })
    }, [])
    const [filter, setFilter] = React.useState('');

    return (
        <div className='games_container'>
            <div className='header-game'>
                <div className='top-title'>
                    <Typography sx={{ textTransform: 'uppercase' }} variant='h4' color='white' className='games_title'>Jeux à la une</Typography>
                </div>
                <div className='btn-container'>
                    <Button className={`btn-tag ${filter === "PC" ? "active-btn" : ""}`} onClick={() => setFilter('PC')} >PC</Button>
                    <Button className={`btn-tag ${filter === "Console" ? "active-btn" : ""}`} onClick={() => setFilter('Console')}>Console</Button>
                    <Button className={`btn-tag ${filter === "Mobile" ? "active-btn" : ""}`} onClick={() => setFilter('Mobile')}>Mobile</Button>

                </div>
            </div>
            <div className='card-container'>
                {data
                    .filter((item) => {
                        if (filter === "") return true;
                        return item.tag.some((tag) => tag.name === filter);
                    })
                    .map((item) => (
                        <div key={item.id} className='card'>
                            <div
                                className="card__img"
                                onMouseEnter={(e) => {
                                    const video = e.currentTarget.querySelector("video");
                                    video.load();
                                }}
                                onMouseLeave={(e) => {
                                    const video = e.currentTarget.querySelector("video");
                                    video.load();
                                }}
                            >
                                <img src={item.img} alt={item.name} />
                                <video className='card_video' src={item.video} preload='none' type="video/webm" autoPlay loop muted></video>
                                <img src={item.btmImg} alt={item.name} />
                            </div>
                            <div className='card-content'>
                                <Typography variant='h5' color='white'>{item.name}</Typography>
                                <Typography sx={{ color: 'rgba(208, 233, 255, 0.6)', textTransform: "uppercase", fontSize: "14px" }}>{item.genre}</Typography>
                                <div className='platform-container'>
                                    {item.platform.map((platform, index) => (
                                        <img className='logo-svg' key={index} src={platform.img} alt={`${item.name} platform ${index}`} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}

            </div>
            <div className='comming-soon'>
                <Typography variant='h4' align='center' sx={{
                    textTransform: 'uppercase'
                }} mt={5} color='white'>A venir</Typography>
                <div className='card-container'>
                    <div className='card'>
                        <div className='card__img'>
                            <img src='https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt2094b1dd785d2dba/639b6960dcd1ca11692e9a78/d4-square-v2.jpg?format=webply&quality=80&auto=webp' alt='' />
                            <video className='card_video' src='https://blz-contentstack-assets.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt670f061c2fc3ff8a/61e09e7d1f8b3a4274c02a51/Tile_Anim_Diablo_IV.webm' preload='none' type="video/webm" autoPlay loop muted></video>
                            <img src='https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/bltab19d596b693dda4/639b6950dcd1ca11692e9a74/d4-logo-square-v2.png?format=webply&quality=80&auto=webp' alt='' />
                        </div>
                        <div className='card-content'>
                            <Typography variant='h5' color='white'>Diablo IV</Typography>
                            <Typography sx={{ color: 'rgba(208, 233, 255, 0.6)', textTransform: "uppercase", fontSize: "14px" }}>Action RPG</Typography>
                            <div className='platform-container'>
                                <img className='logo-svg' src={pc} alt='pc' />
                                <img className='logo-svg' src={ps4} alt='ps4' />
                                <img className='logo-svg' src={xbox} alt='xbox' />

                            </div>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='card__img'>
                            <img src='https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt6115d43ad158a9f8/625744845e831c436d424d79/gryphon-square.jpg?format=webply&quality=80&auto=webp' alt='' />
                            <video className='card_video' src='https://blz-contentstack-assets.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt29c28a3cf51766c3/625750056f43925746abc0bb/Tile_Anim_Gryphon.webm' preload='none' type="video/webm" autoPlay loop muted></video>
                            <img src='https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt236e4dee135416c3/6257448fda5a7125ed751eb6/gryphon-logo-square.png?format=webply&quality=80&auto=webp' alt='' />
                        </div>
                        <div className='card-content'>
                            <Typography variant='h5' color='white'>Warcraft Arclight Rumble</Typography>
                            <Typography sx={{ color: 'rgba(208, 233, 255, 0.6)', textTransform: "uppercase", fontSize: "14px" }}>Jeux mobile d'action et de stratégie</Typography>
                            <div className='platform-container'>
                                <img className='logo-svg' src={mobile} alt='android' />
                                <img className='logo-svg' src={apple} alt='ios' />


                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className='more-game'>
                <Button className='button-download'>Voir tous les jeux</Button>
            </div>
        </div>
    )
}

export default Games